export default {
  meditation: {},
};
